export default "__VITE_ASSET__Bf9r395$__"